export default __webpack_public_path__ + "static/media/lab-activity-03.9e2fd6a2.jpg";